import type {CopilotSpaceGitHubIssueResource, CopilotSpaceGitHubPullRequestResource} from '../../../types'
import {useMutation} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

export class UrlDetails {
  url: string
  owner: string
  repo: string
  number?: number
  type: UrlType
  id: string

  file_path?: string
  errorMessage?: string
  sha?: string

  constructor(
    id: string,
    url = '',
    owner = '',
    repo = '',
    number = 0,
    sha = '',

    file_path = '',
    type: UrlType = 'unknown',
  ) {
    this.id = id
    this.url = url
    this.owner = owner
    this.repo = repo
    this.number = number
    this.type = type

    this.file_path = file_path
    this.sha = sha
  }
}

export type UrlResourceValidationError = {
  id: string
  errors: Record<string, string>
}

type UrlType = 'github_pull_request' | 'github_issue' | 'github_file' | 'unknown'

function resourceMetadataToRailsPayload(resource: UrlDetails) {
  switch (resource.type) {
    case 'github_issue':
    case 'github_pull_request':
      return {
        owner: resource.owner,
        repo: resource.repo,
        number: resource.number,
      }
    case 'github_file':
      return {
        owner: resource.owner,
        repo: resource.repo,

        file_path: resource.file_path,
        sha: resource.sha,
      }
    default:
      throw new Error(`Unsupported resource`)
  }
}

export const useValidateUrlResources = () => {
  const {mutateAsync: validateUrlResources, ...rest} = useMutation({
    mutationFn: async ({input, spaceOwner}: {input: UrlDetails[]; spaceOwner: string | undefined}) => {
      const url = `/copilot/spaces/validate_url_resources`
      const method = 'POST'

      const body = {
        resources_attributes: input.map(r => ({
          id: r.id,

          resource_type: r.type,
          metadata: resourceMetadataToRailsPayload(r),
        })),

        space_owner: spaceOwner,
      }

      const response = await verifiedFetchJSON(url, {
        method,
        body,
      })

      const data = await response.json()
      if (!response.ok) {
        throw data
      }

      return data as Array<CopilotSpaceGitHubPullRequestResource | CopilotSpaceGitHubIssueResource>
    },
  })

  return {
    validateUrlResources,
    ...rest,
  }
}
